export default "__VITE_ASSET__67fdecf1__"